import { render } from "./BaseMonitorTab.vue?vue&type=template&id=4193c6e2&scoped=true&ts=true"
import script from "./BaseMonitorTab.vue?vue&type=script&lang=ts"
export * from "./BaseMonitorTab.vue?vue&type=script&lang=ts"

import "./BaseMonitorTab.vue?vue&type=style&index=0&id=4193c6e2&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4193c6e2"]])

export default __exports__